<script setup>
import { SidebarProvider } from '@/shadcn/components/ui/sidebar'
import { useLocalStorage } from '@vueuse/core'
import StorageKeys from '@/common/storage-keys.js'

const sidebarState = useLocalStorage(StorageKeys.SIDEBAR_STATE, true)

</script>

<template>
  <sidebar-provider
    v-model:open="sidebarState"
  >
    <slot />
  </sidebar-provider>
</template>
